import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import withOptions from 'utils/functions/withOptions.util';
import actionType from 'utils/mw/actionType.util';

const ATAG = 'beActivateTagsTrial';
const AT = actionType(ATAG);

const beActivateTagsTrial = withOptions(({ salonId, name }) =>
  endpoint(H.post, 'salon/v2/:salonId/salon_features/promotion/', {
    AT,
    name: ATAG,
    params: { salonId, name },
    data: { salon_id: salonId, name },
  }),
);

beActivateTagsTrial.AT = AT;
beActivateTagsTrial.ATAG = ATAG;

// noinspection JSUnusedGlobalSymbols
export default beActivateTagsTrial;
